"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppNameSymbol = exports.WixBiSessionSymbol = exports.BISymbol = void 0;
exports.BISymbol = Symbol.for('BI');
exports.WixBiSessionSymbol = Symbol.for('WixBiSessionSymbol');
exports.AppNameSymbol = Symbol.for('appName');
//# sourceMappingURL=bi.js.map